import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { ChromePicker } from 'react-color';
import { findDOMNode } from 'react-dom';
import $ from "jquery";

import { DatePicker } from '@material-ui/pickers';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Switch from '@material-ui/core/Switch';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Tooltip from '@material-ui/core/Tooltip';

import {validateForm, blurValidations} from '../Common/formValidator';
import ModalBox from '../Common/Modals/ModalBox';

import { API } from '../../ws/constants';

import './style.css';

var moment = require('moment');

class AddEditStore extends Component {
    constructor(props) {
        super(props);

        this.state = {
            storeId:this.props.props.match.params.id
            ,openModal:false
            ,showPicker:false
            ,returnTitle: "Erro"
            ,returnText: "Ocorreu algum erro"
            ,editable: (this.props.isAdmin || this.props.loginData.profile.Stores.permission === 1)
            ,somethingWasEdited: false
            ,fetchManagers:null
            ,storeData:null
            ,loading:false
            ,addEditTitle:"Nova Loja"
            ,sId:""
            ,name:""
            ,shortname:""
            ,country:""
            ,city:""
            ,region:""
            ,postalCode:""
            ,address:""
            ,email:""
            ,generalEmail:""
            ,generalPhone:""
            ,dateOpened:""
            ,managerId:""
            ,color:""
            ,notes:""
            ,isActive:1
        };
    }
    componentDidMount() {
        fetch(API + "getmanagers")
        .then(response => response.json())
        .then(result => this.setState({ fetchManagers: result.data }));

        if(this.state.storeId > 0){
            fetch(API + 'getstores&getbyid=' + this.state.storeId)
            .then(response => response.json())
            .then(result => {
                const storeData = result.data;
                if(result === null || result.shortmsg === "NOK"){
                    this.props.props.history.push('/Stores');
                    return;
                }
                this.setState({
                    storeData
                    , sId: storeData.StoreId
                    , name: storeData.Name
                    , shortname: storeData.Shortname
                    , country: storeData.Country
                    , city: storeData.City
                    , region: storeData.Region
                    , address: storeData.Address
                    , postalCode: storeData.PostalCode
                    , generalEmail: storeData.GeneralEmail
                    , generalPhone: storeData.GeneralPhone
                    , dateOpened: storeData.DateOpened
                    , managerId: storeData.ManagerId
                    , color: storeData.Color
                    , notes: storeData.Notes
                    , isActive: storeData.IsActive
                });
            });
        }
        blurValidations($(findDOMNode(this.refs.editForm)), { validateHiddenFields: true, showErrorMessage: true, dumbValidations: false });
    }

    getMoreData = (storeData) => {
        fetch(API + "getmanagers")
        .then(response => response.json())
        .then(result => this.setState({ fetchManagers: result.data, storeData: storeData, isActive:1 }));
    }

    handleTitleChange = (e) => {this.setState({ [e.target.id]: e.target.value, addEditTitle: e.target.value, somethingWasEdited:true });}
    handleSelectChange = (e) => this.setState({ [e.target.name]: e.target.value, somethingWasEdited:true });
    handleFieldChange = (e) => this.setState({ [e.target.id]: e.target.value, somethingWasEdited:true });
    handleToggle = (e, value) => this.setState({ [e.target.id]: value ? "1" : "0", somethingWasEdited:true });
    handleColorChange = (value) => this.setState({color: value.hex, somethingWasEdited:true});
    handleDateOpenedInputChange = value => this.setState({ dateOpened: value });

    handleSave = (e) => {
        if(!this.state.somethingWasEdited)
            return;

        if(validateForm($(findDOMNode(this.refs.editForm)), { validateHiddenFields: true, showErrorMessage: true, dumbValidations: false })){
            let DEFAULT_QUERY = "savestore&storeid=" + this.state.storeId + "&sid=" + this.state.sId.trim() + "&name=" + this.state.name.trim() + "&shortname=" + this.state.shortname.trim()
                                + "&country=" + this.state.country.trim() + "&city=" + this.state.city.trim() + "&region=" + this.state.region.trim() + "&postalcode=" + this.state.postalCode.trim()
                                + "&address=" + this.state.address.trim() + "&generalemail=" + this.state.generalEmail.trim() + "&generalphone=" + this.state.generalPhone.trim()
                                + "&dateopened=" + moment(this.state.dateOpened).format('YYYY-MM-DD') + "&managerid=" + this.state.managerId + "&color=" + this.state.color.replace("#","")
                                + "&notes=" + this.state.notes.trim() + "&isactive=" + this.state.isActive + "&cur_userid=" + this.props.loginData.Id + "&cur_username=" + this.props.loginData.Name;

            this.setState({loading:true});
            fetch(API + DEFAULT_QUERY)
            .then(response => response.json())
            .then(result => {this.setState({ returnTitle: result.shortmsg === "OK" ? "Sucesso" : "Erro", returnText: result.message , openModal: true, loading:false })});
        }
    }

    handleDelete = (e) => {
        if(window.confirm("Tem a certeza que quer apagar esta loja?")){
            this.setState({loading:true});
            fetch(API + 'deletestore&storeid=' + this.state.storeId + "&cur_userid=" + this.props.loginData.Id + "&cur_username=" + this.props.loginData.Name)
            .then(response => response.json())
            .then(result => {
                this.setState({ returnTitle: result.shortmsg === "OK" ? "Sucesso" : "Erro", returnText: result.message , openModal: true, loading:false });
            });
        }
    }

    showPicker = () => {
        this.setState({showPicker:true});
    }

    hidePicker = () => {
        this.setState({showPicker:false});
    }

    modalCallBack = (result, keepModalOpen) => {
        this.setState({ openModal: keepModalOpen });
        this.props.props.history.push('/Stores');
    }

    renderManagerOptions = (e) => {
        const managers = this.state.fetchManagers;
        if(managers===null)
            return;

        const items = [<MenuItem value="0" key="0" disabled={true}>Escolha uma opção</MenuItem>];
        for (let i=0,n=managers.length;i<n;i++) {
            items.push(<MenuItem value={managers[i].Id} key={managers[i].Id}>{managers[i].StaffId + " - " + managers[i].FirstName + " " + managers[i].LastName}</MenuItem>);
        }
        return items;
    }

    render() {
        const { isAdmin, loginData } = this.props;
        const { editable, storeId } = this.state;

        const optsManagers = this.renderManagerOptions()
              , addEditTitle = storeId > 0 && this.state.storeData !== null ? this.state.storeData.Name : this.state.addEditTitle
              , loadingClass = this.state.loading ? " ajaxLoading" : "";

        return (
            <div id="addEditStorePage" ref="editForm" className={"form addEditPage" + loadingClass}>
                <div className="row">
                    <div className="col-12">
                        <h1><i className="fa fa-building"></i> {addEditTitle}                  
                        { (isAdmin || loginData.profile.Stores.isActive) && 
                            <span className="float-right">
                                <FormControlLabel
                                    label="Ativo"
                                    control={
                                        <Switch
                                            id="isActive"
                                            checked={!!+this.state.isActive}
                                            disabled={!(isAdmin || (loginData.profile.Stores.isActive.permission === 1 && editable))}
                                            onChange={this.handleToggle}
                                            color="primary"/>
                                    }/>
                            </span>
                        }
                        <span className="fieldHolder colorPickerHolder float-right">
                            <label htmlFor="colorPicker">Escolher Côr</label>
                            <div className="colorPickerTrigger" onClick={this.state.showPicker ? this.hidePicker : this.showPicker} style={{backgroundColor:this.state.color}}></div>
                            { this.state.showPicker &&
                                <div>
                                    <ChromePicker
                                        id="colorPicker"
                                        color={this.state.color}
                                        defaultValue="#FF0000"
                                        onChangeComplete={this.handleColorChange}
                                    />
                                    <div className="cover" onClick={ this.hidePicker }/>
                                </div>
                            }
                        </span>
                        </h1>
                    </div>
                </div>
                { storeId !== "New" && (isAdmin || loginData.profile.Schedules) &&
                    <div className="row">
                        <div className="col-12">
                            <Tooltip
                                title={"Ver Stock de " + this.state.name}
                                enterDelay={200}>
                                <span className="float-right"><i className="fa fa-clock"></i> <NavLink to={"/Stores/StoreStock/"+storeId}>Ver Stock</NavLink></span>
                            </Tooltip>
                        </div>
                    </div>
                }
                <div className="row">
                    <div className="col-12 col-md-6">
                        <div className="fieldHolder required">
                            <TextField fullWidth
                                       id="name"
                                       value={this.state.name}
                                       onChange={this.handleTitleChange}
                                       label="Nome"
                                       placeholder="Introduza o nome"
                                       disabled={!editable}
                                       data-empty-error-message="Este campo não pode estar vazio" />
                        </div>
                        <div className="fieldHolder required">
                            <TextField fullWidth
                                       id="shortname"
                                       value={this.state.shortname}
                                       onChange={this.handleFieldChange}
                                       disabled={!editable}
                                       label="Abreviatura"
                                       placeholder="Introduza a abreviatura"
                                       data-empty-error-message="Este campo não pode estar vazio" />
                        </div>
                        <div className="fieldHolder">
                            <TextField fullWidth
                                       id="country"
                                       value={this.state.country}
                                       onChange={this.handleFieldChange}
                                       disabled={!editable}
                                       label="País"
                                       placeholder="Introduza o País" />
                        </div>
                        <div className="fieldHolder">
                            <TextField fullWidth
                                       id="city"
                                       value={this.state.city}
                                       onChange={this.handleFieldChange}
                                       disabled={!editable}
                                       label="Cidade"
                                       placeholder="Introduza a Cidade" />
                        </div>
                        <div className="fieldHolder">
                            <TextField fullWidth
                                       id="region"
                                       value={this.state.region}
                                       onChange={this.handleFieldChange}
                                       disabled={!editable}
                                       label="Região"
                                       placeholder="Introduza a Região" />
                        </div>
                        <div className="fieldHolder">
                            <TextField fullWidth
                                       id="postalCode"
                                       value={this.state.postalCode}
                                       onChange={this.handleFieldChange}
                                       disabled={!editable}
                                       label="Código Postal"
                                       placeholder="Introduza o Código Postal" />
                        </div>
                        <div className="fieldHolder">
                            <TextField fullWidth
                                       id="address"
                                       value={this.state.address}
                                       onChange={this.handleFieldChange}
                                       disabled={!editable}
                                       multiline
                                       rows={4}
                                       label="Morada"
                                       placeholder="Introduza a morada" />
                        </div>
                    </div>
                    <div className="col-12 col-md-6">
                        <div className="fieldHolder">
                            <TextField fullWidth
                                       id="sId"
                                       value={this.state.sId}
                                       onChange={this.handleFieldChange}
                                       label="Id Interno"
                                       placeholder="Introduza o Id Interno da loja"
                                       disabled={this.props.loginData.AccessLevel >= 1} />
                        </div>
                        <div className="fieldHolder required validEmail">
                            <TextField fullWidth
                                       id="generalEmail"
                                       value={this.state.generalEmail}
                                       onChange={this.handleFieldChange}
                                       disabled={!editable}
                                       label="Email Geral"
                                       placeholder="Introduza o email geral"
                                       data-email-error-message="Este email não está correto."
                                       data-empty-error-message="Este campo não pode estar vazio" />
                        </div>
                        <div className="fieldHolder required">
                            <TextField fullWidth
                                       id="generalPhone"
                                       value={this.state.generalPhone}
                                       onChange={this.handleFieldChange}
                                       disabled={!editable}
                                       label="Telefone Geral"
                                       placeholder="Introduza o telefone geral"
                                       data-empty-error-message="Este campo não pode estar vazio" />
                        </div>
                        <div className="fieldHolder required selectField">
                            <FormControl fullWidth>
                                <InputLabel htmlFor="managerId">Gerente da Loja</InputLabel>
                                <Select id="managerId"
                                        name="managerId"
                                        value={this.state.managerId}
                                        onChange={this.handleSelectChange}
                                        disabled={!editable}
                                        data-empty-error-message="Este campo não pode estar vazio">
                                  {optsManagers}
                                </Select>
                            </FormControl>
                        </div>
                        <div className="fieldHolder">
                            <DatePicker
                                fullWidth
                                id="dateOpened"
                                label="Data de Abertura"
                                placeholder="Data de Abertura"
                                format="DD/MM/YYYY"
                                disabled={!editable}
                                value={this.state.dateOpened || ""}
                                locale="pt-PT"
                                onChange={this.handleDateOpenedInputChange}
                            />
                        </div>
                        <div className="fieldHolder">
                            <TextField fullWidth
                                       id="notes"
                                       value={this.state.notes}
                                       onChange={this.handleFieldChange}
                                       disabled={!editable}
                                       multiline
                                       rows={4}
                                       label="Observações" />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 buttonsHolder">
                        <Button onClick={this.props.props.history.goBack} variant="contained" className="defaultButton">Voltar</Button>
                        { (isAdmin || loginData.profile.Stores.DEL) && this.state.userId !== "New" && <Button onClick={this.handleDelete} className="button button-danger" variant="contained">Apagar Loja</Button>}
                        { editable && <Button onClick={this.handleSave} className="button float-right" variant="contained" color="primary"><i className='fa fa-check'></i> Salvar</Button>}
                    </div>
                </div>
                {this.state.openModal && <ModalBox modalCallBack={this.modalCallBack} isActive={this.state.openModal} modalHtml={<div className="col-12"><h2>{this.state.returnTitle}</h2><p>{this.state.returnText}</p></div>} />}
            </div>
        );
    }
}

export default AddEditStore;
